import React from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  ButtonBase,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
// forwardRef-elt Chevron
import useStyles from "./sidebar-submenu.style";
import chevronDoubleRigth from "@iconify/icons-mdi/chevron-double-right";
import { OcSidebarChevron } from "oc/components";
import { useOcIsMobile } from "oc/hooks/use-is-mobile";

interface OcSidebarSubmenuProps {
  id: string;
  label: string;
  translation: string;
  onMenuChange: (id: string) => void;
  narrowMenuOpened: boolean;
}

export const OcSidebarSubmenu: React.FC<OcSidebarSubmenuProps> = ({
  id,
  label,
  translation,
  onMenuChange,
  narrowMenuOpened,
}) => {
  const { t } = useTranslation();
  let menuLabel = t(translation) || label;
  const classes = useStyles();
  const isMobile = useOcIsMobile();

  return (
    <Box>
      <ButtonBase
        sx={{
          width: "100%",
        }}
      >
        <ListItem
          id={id}
          component="div"
          className={classes.linkItem}
          onClick={() => onMenuChange(id)}
        >
          {!narrowMenuOpened && !isMobile ? (
            <Box minWidth="24px" maxWidth="24px">
              <OcSidebarChevron icon={chevronDoubleRigth} />
            </Box>
          ) : (
            <Box minWidth="24px" maxWidth="24px" />
          )}
          <ListItemText
            sx={{
              padding: "2px 16px",
            }}
          >
            <Typography variant="body1" color="#fff">
              {menuLabel}
            </Typography>
          </ListItemText>
          <OcSidebarChevron icon={chevronDoubleRigth} />
        </ListItem>
      </ButtonBase>
    </Box>
  );
};

export default OcSidebarSubmenu;
